import {
  Box,
  Card,
  Step,
  StepIcon,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledStepIcon = styled(StepIcon)(({ theme }) => ({
  "&.Mui-completed": {
    color: theme.palette.success.main,
  },
}));

const RequestSteps = ({ activeStep, steps, shownStep, setShownStep }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "100%",
          maxHeight: { xs: "50vh", md: "calc(100vh - 250px)" },
          minHeight: "300px",
          overflow: "auto",
          p: 2,
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "grey.100",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "grey.400",
            borderRadius: "10px",
            "&:hover": {
              backgroundColor: "grey.500",
            },
          },
        }}
      >
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((step, index) => (
            <Step key={step.stepTitle}>
              <StepLabel
                StepIconComponent={StyledStepIcon}
                optional={
                  index === steps.length - 1 ? (
                    <Typography variant="caption" color="text.secondary">
                      آخرین مرحله
                    </Typography>
                  ) : null
                }
                sx={{
                  cursor: index <= activeStep ? "pointer" : "default",
                  py: 0.5,
                  px: 1,
                  mx: -1,
                  borderRadius: 1,
                  transition: "all 0.2s",
                  ...(shownStep === index
                    ? {
                        bgcolor: "primary.lighter",
                        ".MuiStepLabel-label": {
                          fontWeight: "700 !important",
                          color: "primary.main",
                        },
                      }
                    : {
                        "&:hover":
                          index <= activeStep
                            ? {
                                bgcolor: "grey.50",
                              }
                            : {},
                      }),
                }}
                onClick={() => index <= activeStep && setShownStep(index)}
              >
                {step.stepTitle}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Card>
  );
};

export default RequestSteps;
